import * as jQuery from 'jquery';
import { PerfectScrollbarConfigInterface, PerfectScrollbarDirective } from 'ngx-perfect-scrollbar';
import * as _ from 'underscore';

import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';

import { EmitterService } from '../../../../core/utility/services/emitter.service';
import { UtilityService } from '../../../../core/utility/services/utility.service';
import { DataTableConfig, DownloadConfig } from '../../../analytics-core/interfaces/widget.interface';
import { EVENT_EMITTERS, PREFIXES } from '../../../analytics/constants/analytics.constants';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { WidgetCore } from '../../interfaces/widget.core.interface';
import { WidgetLibraryService } from '../../services/widget-library.service';

export interface AdKeyword {
	abs_top: any;
	abs_top_impression_share: number;
	adGroupId: string;
	adGroupName: string;
	avgPosition: number;
	clicks: number;
	ctr: number;
	impressions: number;
	keyword: string;
	preCutOffImpressions: number;
	top_impression_share: number;
	totalAbsImpressions: number;
	totalTopImpressions: number;
	weightedImpressions: number;
}

@Component({
	selector: 'app-sem-keywords-v1',
	styleUrls: ['./sem-keywords-v1.component.css'],
	templateUrl: './sem-keywords-v1.component.html'
})
export class SemKeywordsV1Component implements OnInit, WidgetCore, OnDestroy {
	@ViewChild('myTable') table: any;
	@Input() sectiontitle: string;
	@Input() key: string;
	@Input() downloadconfig: string;
	@Input() datatableconfig;
	@Input() sectionclass: string;
	@Input() sortdataby: string;
	@Input() legend;
	@Input() downloadcsvcolumns: any;
	public isGoliveNotStarted: boolean = false;
	public showLoad = true;
	public rows: any[] = [];
	public columns: any[] = [];
	public expanded: any = {};
	public expand: any = false;
	public tableConfig: DataTableConfig = {} as DataTableConfig;
	public downloadConfiguration: DownloadConfig;
	public expandedRows = [];
	public primaryColorTitle: boolean = false;
	public isVerticalScrollable;
	public footerHeight;
	public innerRowHeight;
	public rowLimit;
	public isR10: boolean = false;
	public tooltipOptions = {
		animation: 'fade',
		arrow: true,
		duration: 750,
		dynamicTitle: true,
		position: 'top',
		scale: 'big'
	};
	public hasData = false;
	public downloadIcon: any = null;
	public newTabXLSXRequired: boolean = false;
	public config: PerfectScrollbarConfigInterface = {};
	@ViewChild(PerfectScrollbarDirective) directiveScroll: PerfectScrollbarDirective;
	public reloadSubscription;
	public widgetDataSubscription;
	private scrollBarWidth;
	private progressBarData = {};

	constructor(
		protected analyticsService: AnalyticsService,
		protected analyticsDataModel: AnalyticsDataModel,
		protected widgetLibraryService: WidgetLibraryService
	) {
		this.reloadSubscription = EmitterService.get(EVENT_EMITTERS.RELOAD).subscribe((response: any) => {
			this.requestData();
		});
	}

	ngOnInit(): void {
		this.datatableconfig = JSON.parse(decodeURI(this.datatableconfig));
		this.tableConfig = this.datatableconfig;
		this.rowLimit = this.tableConfig.isVerticalScrollable
			? undefined
			: this.tableConfig.limit
			? this.tableConfig.limit
			: 10;
		this.scrollBarWidth = this.widgetLibraryService.scrollBarWidth;
		this.downloadConfiguration = JSON.parse(decodeURI(this.downloadconfig));
		this.downloadIcon = this.analyticsDataModel.config.downloadIcon
			? this.analyticsDataModel.config.downloadIcon
			: this.downloadIcon;
		this.primaryColorTitle = this.analyticsDataModel.config.version.toLowerCase() === 'r11' ? true : false;
		this.isR10 = this.analyticsDataModel.config.version === 'R10' ? true : false;
		this.downloadcsvcolumns = this.downloadcsvcolumns ? JSON.parse(decodeURI(this.downloadcsvcolumns)) : [];
		if (
			this.downloadConfiguration &&
			this.downloadConfiguration.permission &&
			this.downloadConfiguration?.permission['flags']
		) {
			this.newTabXLSXRequired = !this.downloadConfiguration.permission['flags']
				.map((permission) => {
					return this.analyticsDataModel
						.checkComponentForPermission({ permission: { flags: [permission] } })
						.toString();
				})
				.includes('false');
		}
		this.requestData();
	}

	getClassName(name: string): string {
		if (this.columns.length === 7) {
			return name + 'RowAll';
		} else if (this.columns.length === 6) {
			return name + 'Row';
		}
		return name + 'RowAvg';
	}

	ngOnDestroy(): void {
		if (this.reloadSubscription) {
			this.reloadSubscription.unsubscribe();
		}
		if (this.widgetDataSubscription) {
			this.widgetDataSubscription.unsubscribe();
		}
	}
	getMaxValues(rowData: any, metric: any): boolean {
		const index = PREFIXES.MAX_PREFIX + metric;
		if (rowData[index]) {
			return true;
		}
		return false;
	}

	requestData(): void {
		this.showLoad = true;
		this.widgetDataSubscription = this.analyticsService.processWidgetRequest(this.key).subscribe((res: any) => {
			this.showLoad = false;
			if (res.success && res.data.length > 0) {
				this.analyticsService.checkDateRange();
				this.isGoliveNotStarted = this.analyticsService.isGoliveNotStarted;
				this.setCutOffDate();
				this.hasData = true;
				jQuery('.sem-keywords-header, .sem-keywords-wrapper').css('display', 'block');
				const adKeywords: AdKeyword[] = this.mapKeywordsDataToInterface(res.data);
				this.processResponseData(adKeywords);
			} else {
				this.hasData = false;
				jQuery('.sem-keywords-header, .sem-keywords-wrapper').css('display', 'none');
				this.rows = [];
			}
		});
	}

	setCutOffDate(): void {}

	getPropMax(data: any[], prop: any): number {
		return data.reduce((max, p) => {
			p[prop] = parseFloat(p[prop]);
			return p[prop] > max ? p[prop] : max;
		}, parseFloat(data[0][prop]));
	}

	getPercentage(value: number, rowData: any[], metric: any): object {
		const maxValueIndex = PREFIXES.MAX_PREFIX + metric;
		const maxValue = rowData[maxValueIndex];
		const percentage = (value / maxValue) * 100;
		return { width: `${Math.floor(percentage)}%` };
	}

	processDataForProgressBar(data: any[]): any[] {
		for (const adWord of data) {
			for (const colObj of this.datatableconfig.columns) {
				if (colObj.columnHasProgressBar) {
					if (!this.innerRowHeight) {
						this.innerRowHeight = 150;
					}
					adWord['max_' + colObj.columnKey] = this.getPropMax(adWord.keywords, colObj.columnKey);
				}
			}
		}
		return data;
	}

	processResponseData(adKeywords: AdKeyword[]): void {
		this.columns = this.generateColumnConfigurationForDataTable();
		const obj: any = {};
		let data = [];
		for (const adKeyword of adKeywords) {
			adKeyword['expand'] = false;
			const key = adKeyword.adGroupId;
			if (obj[key]) {
				for (const column of this.columns) {
					if (column.prop !== 'name') {
						obj[key][column.prop] += adKeyword[column.prop];
					}
				}
				obj[key]['preCutOffImpressions'] += adKeyword.preCutOffImpressions;
				obj[key]['keywords'].push(adKeyword);
			} else {
				obj[key] = [adKeyword];
				for (const column of this.columns) {
					if (column.prop === 'name') {
						obj[key][column.prop] = adKeyword.adGroupName;
					} else {
						obj[key][column.prop] = adKeyword[column.prop];
					}
				}
				obj[key]['preCutOffImpressions'] = adKeyword.preCutOffImpressions;
				obj[key]['keywords'] = [adKeyword];
				obj[key]['expanded'] = false;
				if (!obj[key]['name']) {
					obj[key]['name'] = adKeyword.adGroupName;
				}
			}
		}
		// tslint:disable-next-line: forin
		for (const key in obj) {
			const totalWeightedImpressions = UtilityService.calculateSumFromArray(
				_.pluck(obj[key]['keywords'], 'weightedImpressions')
			);
			const totalAbsoluteImpressions = UtilityService.calculateSumFromArray(
				_.pluck(obj[key]['keywords'], 'totalAbsImpressions')
			);
			const totalTopImpressions = UtilityService.calculateSumFromArray(
				_.pluck(obj[key]['keywords'], 'totalTopImpressions')
			);

			obj[key]['avgPosition'] =
				obj[key].preCutOffImpressions > 0
					? UtilityService.truncate(totalWeightedImpressions / obj[key].preCutOffImpressions, 2)
					: 0;
			obj[key]['avgPosition'] = parseFloat(obj[key]['avgPosition']).toFixed(2);
			obj[key]['ctr'] = ((obj[key].clicks / obj[key].impressions) * 100).toPrecision(3);
			obj[key]['ctr'] = parseFloat(obj[key]['ctr']).toFixed(2);
			obj[key]['abs_top_impression_share'] = UtilityService.truncate(
				totalAbsoluteImpressions / obj[key].impressions,
				2
			);
			obj[key]['abs_top_impression_share'] = parseFloat(obj[key]['abs_top_impression_share']).toFixed(
				this.isR10 ? 0 : 2
			);
			obj[key]['top_impression_share'] = UtilityService.truncate(totalTopImpressions / obj[key].impressions, 2);
			obj[key]['top_impression_share'] = parseFloat(obj[key]['top_impression_share']).toFixed(this.isR10 ? 0 : 2);
			data.push(obj[key]);
		}
		if (this.datatableconfig.columns) {
			if (this.isR10) {
				data.map(
					(item) =>
						(item['keywords'] = _.sortBy(
							_.sortBy(_.sortBy(item.keywords, 'keyword').reverse(), 'impressions'),
							'clicks'
						).reverse())
				);
			} else if (!this.isR10) {
				data.map(
					(item) =>
						(item['keywords'] = this.sortdataby
							? _.sortBy(_.sortBy(item.keywords, 'impressions'), this.sortdataby).reverse()
							: _.sortBy(item.keywords, 'impressions').reverse())
				);
			}

			data = this.processDataForProgressBar(data);
		}
		this.isVerticalScrollable = this.datatableconfig.isVerticalScrollable
			? this.datatableconfig.isVerticalScrollable
			: false;
		this.footerHeight = this.isVerticalScrollable ? 0 : 50;
		this.setRows(data);
	}

	setRows(data: any[]): void {
		setTimeout(() => {
			this.rows = this.sortdataby
				? _.sortBy(_.sortBy(data, 'impressions'), this.sortdataby).reverse()
				: _.sortBy(data, 'impressions').reverse();
			jQuery('.datatable-body').css('overflow-y', 'scroll');
		});
	}

	generateColumnConfigurationForDataTable(): any[] {
		const dateSet = {
			depricatedDate: this.analyticsDataModel.depricatedDate,
			endDate: this.analyticsDataModel.endDate,
			goLiveDate: this.analyticsDataModel.goLiveDate,
			startDate: this.analyticsDataModel.startDate
		};
		const columnsConfig = UtilityService.checkForVisibilityPermissions(this.tableConfig.columns, dateSet);
		const sortedColumnConfig = _.sortBy(columnsConfig, 'columnOrder');
		const columns = [];
		for (const colConfig of sortedColumnConfig) {
			const colObj: any = {} as any;
			colObj.name = colConfig.columnName;
			colObj.shortName = colConfig.columnNameShort;
			colObj.prop = colConfig.columnKey;
			colObj.headerClass = colConfig.columnHeaderClass;
			colObj.cellClass = colConfig.columnCellClass;
			colObj.hasProgressBar = colConfig.columnHasProgressBar;
			colObj.showTitle = colConfig.columnShowTitle;
			colObj.columnKey = colConfig.columnKey;
			colObj.suffix = colConfig.columnSuffix;
			colObj.flexGrow = colConfig.columnFlexGrow ?? 1;
			colObj.resizeable = false;
			colObj.columnHasTooltip = colConfig.columnHasTooltip;
			colObj.columnTooltip = colConfig.columnTooltip;
			columns.push(colObj);
		}
		return columns;
	}

	mapKeywordsDataToInterface(responseData: any[]): any[] {
		const adKeywords: AdKeyword[] = [];
		for (const response of responseData) {
			const adKeyword: AdKeyword = {} as AdKeyword;
			adKeyword.adGroupId = response.adgroup_id;
			adKeyword.adGroupName = response.adgroup_name;
			adKeyword.keyword = response.keyword;
			adKeyword.impressions = UtilityService.isUndefinedOrNull(response.impressions)
				? 0
				: parseFloat(response.impressions);
			adKeyword.preCutOffImpressions = UtilityService.isUndefinedOrNull(response.pre_cut_off_impressions)
				? 0
				: parseFloat(response.pre_cut_off_impressions);
			adKeyword.clicks = UtilityService.isUndefinedOrNull(response.clicks) ? 0 : parseFloat(response.clicks);
			adKeyword.avgPosition = UtilityService.isUndefinedOrNull(response.avg_position)
				? 0
				: parseFloat(response.avg_position);
			adKeyword.abs_top_impression_share = UtilityService.isUndefinedOrNull(response.abs_top_impression_share)
				? 0
				: parseFloat(response.abs_top_impression_share);
			adKeyword.top_impression_share = UtilityService.isUndefinedOrNull(response.top_impression_share)
				? 0
				: parseFloat(response.top_impression_share);
			adKeyword.weightedImpressions = adKeyword.preCutOffImpressions * adKeyword.avgPosition;
			adKeyword.totalAbsImpressions = adKeyword.impressions * adKeyword.abs_top_impression_share;
			adKeyword.totalTopImpressions = adKeyword.impressions * adKeyword.top_impression_share;
			adKeyword.ctr = response.ctr > 0 ? response.ctr : Number(response.ctr).toPrecision(3);
			adKeywords.push(adKeyword);
		}
		return adKeywords;
	}

	closeRows(): void {
		for (const adKeyword of this.rows) {
			adKeyword['expand'] = false;
		}
		this.table.rowDetail.collapseAllRows();
	}

	toggleExpandRow(row: any): void {
		let flag = false;
		if (row.expand === true) {
			flag = true;
		}

		for (const adKeyword of this.rows) {
			adKeyword['expand'] = false;
		}
		jQuery('.datatable-body-cell.adGroupCell.sort-active')
			.find('i.fa.fa-caret-down.fa-lg')
			.removeClass('fa fa-caret-down fa-lg')
			.addClass('fa fa-caret-right fa-lg');
		jQuery('.datatable-body-cell.expand.sort-active')
			.find('i.fa.fa-caret-down.fa-lg')
			.removeClass('fa fa-caret-down fa-lg')
			.addClass('fa fa-caret-right fa-lg');
		if (this.analyticsDataModel.config.version === 'R10' && !flag) {
			jQuery('.keywords-table-section .ngx-datatable .datatable-body-row').addClass('active');
		} else if (flag) {
			jQuery('.keywords-table-section .ngx-datatable .datatable-body-row').removeClass('active');
		}

		this.table.rowDetail.collapseAllRows();

		let toggleIndex = -1;
		if (flag === true) {
			toggleIndex = 0;
		} else {
			row.expand = !row.expand;
		}

		if (toggleIndex > -1) {
			this.expandedRows.splice(toggleIndex, 1);
		} else {
			this.expandedRows.push(row);
			this.table.rowDetail.toggleExpandRow(row);
		}

		setTimeout(() => {
			jQuery('.sem-keywords-table .datatable-row-detail').css('min-height', '10px');
			jQuery('.sem-keywords-table .datatable-row-detail').css('height', 'auto');
		});
		this.changePage(row);
	}

	changePage(row: any): void {}

	downloadCSV(e: any): void {
		e.preventDefault();
		this.analyticsService.downloadCSV(
			this.downloadConfiguration.csvQueryKey ? this.downloadConfiguration.csvQueryKey : this.key,
			this.downloadConfiguration.fileName,
			this.downloadcsvcolumns,
			null,
			this.newTabXLSXRequired ? this.downloadConfiguration.newTabCsvQueryKey : '',
			this.newTabXLSXRequired ? this.downloadConfiguration.newTabCsvFileName : ''
		);
	}
}
